import React, { FC } from 'react';
import CurrencyTable from './table/currencyTable.component';
import CurrencyChart from './chart/chart.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useAssetClassReportPageModel } from '../../../../api/rs-hg/asset-class/hooks/queries';
import {
  CurrencyServerData,
  isCurrencyServerData,
} from './table/currencyTable.data';

const Currency: FC<FundInfoComponentProps> = (props) => {
  const { positionDate, fundId } = props;
  const { data, isLoading, isFetching, isError, error } = useAssetClassReportPageModel<CurrencyServerData>({
    fundId,
    reportKey: 'currency_exposure',
    positionDate,
    isReportData: isCurrencyServerData,
  });

  return (
    <QueryBoundary<CurrencyServerData>
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      error={error}
      data={data?.data}
      noDataMessage="No In-Scope or Available Data"
      errorMessage="No In-Scope or Available Data"
    >
      {(currencyData) => (
        <>
          <CurrencyTable
            currencyData={currencyData}
            isFetching={isFetching}
          />
          <CurrencyChart
            currencyData={currencyData}
            isFetching={isFetching}
          />
        </>
      )}
    </QueryBoundary>
  );
};

export default Currency;
